import { render, staticRenderFns } from "./SoftwareDownloadsPage.vue?vue&type=template&id=39c0b3a8&scoped=true"
import script from "./SoftwareDownloadsPage.vue?vue&type=script&lang=ts"
export * from "./SoftwareDownloadsPage.vue?vue&type=script&lang=ts"
import style0 from "./SoftwareDownloadsPage.vue?vue&type=style&index=0&id=39c0b3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c0b3a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VFlex,VLayout,VTabItem,VTabsItems})
